import { UserLimit } from "@data-types/account-settings/MyLimits";
import { LimitDurationDataType } from "@data-types/membership/registration";

export function sortDurations<T extends UserLimit | LimitDurationDataType>(
	durations: T[] | null
): T[] {
	if (durations == null) {
		return [];
	}
	return durations?.sort((a, b) => {
		const unitDiff = a.units - b.units;
		if (unitDiff !== 0) return unitDiff;

		if ("gamingLimitTypeAbrv" in a && "gamingLimitTypeAbrv" in b) {
			if (a.gamingLimitTypeAbrv === "loss-limit-de") return 1;
			if (b.gamingLimitTypeAbrv === "loss-limit-de") return -1;
		}

		return 0;
	});
}
